import { App, ModalFuncProps } from 'antd';
import { useI18n } from '@/hooks/use-i18n';

// 确认提示主题
const CONFIRM_TIP_THEME: Partial<ModalFuncProps> = {
  icon: null,
  centered: true,
  closable: true,
  maskClosable: true,
  className: 'w-[400px] [&_.ant-modal-close]:!top-5',
  styles: {
    content: { padding: '0 16px 16px' },
  },
  okButtonProps: {
    className:
      '!h-10 !ms-4 hover:!bg-[#7171EE] hover:!text-white !font-semibold !border-none !outline-none',
  },
  cancelButtonProps: {
    className:
      '!h-10 !bg-[#7171EE1A] !text-[#7171ee] hover:!bg-[#7171EE1A] hover:!text-[#7171ee] !font-semibold !border-none !outline-none',
  },
};

const useModalMethod = () => {
  const { modal } = App.useApp();
  const { t } = useI18n('common');

  const confirmTip = (params: Partial<ModalFuncProps> & { key?: string }) => {
    const {
      title = t('tip'),
      content,
      okText = t('confirm'),
      cancelText = t('cancel'),
      ...rest
    } = params;
    return modal.confirm({
      ...CONFIRM_TIP_THEME,
      title: (
        <div className="h-14 flex items-center justify-center">{title}</div>
      ),
      content: <div className="pt-6 pb-8 px-4">{content}</div>,
      okText,
      cancelText,
      ...rest,
    });
  };

  return {
    ...modal,
    confirmTip,
  };
};

export default useModalMethod;
